import { CheckCircle2, AlertTriangle, XCircle, Info, X } from 'lucide-react';
import { useToastStore, type Toast } from '@/hooks/useToast';
import { cn } from '@/lib/utils';

const VARIANT_STYLES: Record<NonNullable<Toast['variant']>, { bg: string; icon: React.ReactNode }> = {
  default: { bg: 'bg-slate-900 text-white', icon: <Info className="h-4 w-4 text-slate-300" /> },
  success: { bg: 'bg-emerald-600 text-white', icon: <CheckCircle2 className="h-4 w-4" /> },
  warning: { bg: 'bg-amber-500 text-white', icon: <AlertTriangle className="h-4 w-4" /> },
  destructive: { bg: 'bg-red-600 text-white', icon: <XCircle className="h-4 w-4" /> },
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <div className="pointer-events-none fixed top-4 right-4 z-[200] flex flex-col gap-2 max-w-sm">
      {toasts.map((t) => {
        const styles = VARIANT_STYLES[t.variant || 'default'];
        return (
          <div
            key={t.id}
            role="status"
            className={cn(
              'pointer-events-auto flex items-start gap-3 rounded-lg px-4 py-3 shadow-xl',
              'animate-in slide-in-from-right-5 fade-in',
              styles.bg,
            )}
          >
            <div className="mt-0.5">{styles.icon}</div>
            <div className="flex-1 min-w-0">
              {t.title && <div className="text-sm font-semibold">{t.title}</div>}
              {t.description && <div className="text-xs opacity-90 mt-0.5">{t.description}</div>}
            </div>
            <button onClick={() => dismiss(t.id)} className="opacity-70 hover:opacity-100">
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
